import { CommonFields } from 'src/careflow/ph-core/admin/permissions/types';
import { AxiosResponse } from 'axios';
import { apiClient } from 'src/careflow/ph-core/api_client/api_client';

export enum RegistryValueType {
  STRING = 'string',
  NUMBER = 'number',
  CodeableConcept = 'codeableConcept',
  BOOLEAN = 'boolean',
}

export enum RegistryInputMode {
  MANUAL = 'manual',
  SELECTION = 'selection'
}

export interface RegistryFilter {
  keyRegistry?: string;
  groupIdentifier?: string;
}

export interface Registry extends Partial<CommonFields> {
  keyRegistry: string;
  keyValue: string;
  groupIdentifier: string;
  inputMode: RegistryInputMode | null;
  valueType: RegistryValueType | null;
  keyDescription: string;
}

const baseUrl = '/registry';

export const getRegistries = async (
  groupIdentifier?: string,
  keyRegistry?: string
): Promise<Registry[]> => {
  const searchParams = new URLSearchParams();
  groupIdentifier && searchParams.append('groupIdentifier', groupIdentifier);
  keyRegistry && searchParams.append('keyRegistry', keyRegistry);

  const response = await apiClient.get<Registry[]>(baseUrl, { params: searchParams });
  return response;
};

export const createRegistry = async (
  payload: Registry,
): Promise<AxiosResponse<Registry> | never> => {
  const response: any = await apiClient.post(baseUrl, payload);
  return response;
}

export const updateRegistry = async (
  payload: Registry,
): Promise<AxiosResponse<Registry> | never> => {
  const response: any = await apiClient.patch(`${baseUrl}/${payload?.uuid}`, payload);
  return response;
}